import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'ellf-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoaderComponent {
  @Input()
  show?: boolean = false;

  @Input()
  text? = 'caricamento...';
}
